import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import AppContainer from '~/components/AppContainer';

export default function AppHooksProvider() {
  const navigate = useNavigate();
  const [navigateTo, setNavigateTo] = useState(null);

  useEffect(() => {
    if (navigateTo) {
      navigate(navigateTo);
    }
  }, [navigateTo]);

  return <AppContainer hooks={{setNavigateTo}} />;
}
